import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e92505f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-address" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-label" }
const _hoisted_4 = { class: "form-hint" }
const _hoisted_5 = { class: "saved-addresses" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, null, -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = ["id", "checked", "data-addressid", "disabled"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "address_edit" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "address_delete" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#delete-outline" })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  "aria-hidden": "false",
  class: "fds-modal"
}
const _hoisted_20 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "aria-label": "Indlæser",
  class: "spinner"
}, null, -1))
const _hoisted_22 = {
  class: "spinner-status",
  role: "status"
}
const _hoisted_23 = { class: "modal-content" }
const _hoisted_24 = { class: "modal-header" }
const _hoisted_25 = { class: "modal-title" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "modal-body" }
const _hoisted_31 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-error",
  role: "alert"
}
const _hoisted_32 = { class: "alert-body" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "alert-heading" }, "Fejl", -1))
const _hoisted_34 = { class: "alert-text" }
const _hoisted_35 = {
  class: "form-label",
  for: "address"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = { for: "address" }
const _hoisted_38 = { class: "modal-footer" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 1,
  id: "modal-backdrop",
  class: "modal-backdrop"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.calculationAddressesFormLabel" }),
        _createTextVNode(_toDisplayString(_ctx.countryLongName), 1)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.calculationAddressesFormHint" })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.addresses)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addresses, (address, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("input", {
                      id: `calculation-active-${index + 1}`,
                      checked: address.calculationActive ? address.calculationActive : false,
                      "data-addressid": address.id,
                      disabled: _ctx.isReadOnly,
                      class: "form-checkbox",
                      type: "checkbox",
                      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAddressActive && _ctx.toggleAddressActive(...args)))
                    }, null, 40, _hoisted_9),
                    _createElementVNode("label", {
                      for: `calculation-active-${index + 1}`
                    }, _toDisplayString(_ctx.formatAddress(address)), 9, _hoisted_10),
                    _createElementVNode("div", _hoisted_11, [
                      (!_ctx.isReadOnly)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            "aria-label": "edit address",
                            class: "edit-button",
                            onClick: _withModifiers(($event: any) => (_ctx.toggleAddressModal(address)), ["prevent"])
                          }, _hoisted_14, 8, _hoisted_12))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      (!_ctx.isReadOnly)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            "aria-label": "delete address",
                            class: "delete-button",
                            onClick: _withModifiers(($event: any) => (_ctx.deleteAddress(address)), ["prevent"])
                          }, _hoisted_18, 8, _hoisted_16))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("p", null, [
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              "data-cy-id": "add-address-button",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleAddressModal(null)), ["prevent"]))
            }, [
              _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.calculationAddressesAddButton" })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.toggleModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_ctx.loadingAddress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_SimpleText, { "text-key": "loadspinner.addresscheck" })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("h2", _hoisted_25, [
                (_ctx.modalAddressState === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                      _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.calculationAddressesModalTitleEdit" })
                    ]))
                  : (_ctx.modalAddressState === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                        _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.calculationAddressesModalTitleAdd" })
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                "aria-label": "Luk",
                class: "modal-close button button-unstyled",
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleModal && _ctx.handleModal(...args)), ["prevent"]))
              }, _hoisted_29)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.calculationAddressesModalDescription" })
                ])
              ]),
              _createElementVNode("form", {
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formValidation.clearValidField($event))),
                onInvalidCapture: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.formValidation.handleFormValidity($event, true)), ["prevent"]))
              }, [
                (_ctx.showError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.errorMessage), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass([_ctx.formValidation.formErrors.has('address-required') && 'form-error', "form-group"])
                }, [
                  _createElementVNode("label", _hoisted_35, [
                    _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.calculationAddressesModalField1Label" })
                  ]),
                  _hoisted_36,
                  _createElementVNode("label", _hoisted_37, [
                    _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.calculationAddressesModalField2Label" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    id: "address",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalAddress.address) = $event)),
                    class: "form-input",
                    name: "address",
                    required: "",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.modalAddress.address]
                  ])
                ], 2)
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("button", {
                class: "button button-primary",
                onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveAddress && _ctx.saveAddress(...args)), ["prevent"]))
              }, [
                (_ctx.modalAddressState === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                      _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.calculationAddressesModalSaveButtonEdit" })
                    ]))
                  : (_ctx.modalAddressState === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                        _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.calculationAddressesModalSaveButtonAdd" })
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "button button-secondary",
                onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleModal && _ctx.handleModal(...args)), ["prevent"]))
              }, [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.cancel" })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.toggleModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41))
      : _createCommentVNode("", true)
  ]))
}